import { Box } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { Image3D } from '~/domain/patient/image3d';
import {
    primaryImageState,
    secondaryImageState,
} from '~/state/atoms/image/imageAtoms';
import { OverlayRow } from '../../OverlayLabel';
import ImageDetails from './ImageDetails';
import WindowingControls from './WindowingControls';

interface ImageWindowingRowProps {
    image: Image3D;
    color: string;
}

const ImageWindowingRow = ({ image, color }: ImageWindowingRowProps) => {
    if (!image.windowLevel) {
        return null;
    }

    const metadata = image.seriesMetadata;

    return (
        <OverlayRow sx={{ flexDirection: 'column', alignItems: 'flex-start' }}>
            <ImageDetails metadata={metadata} color={color} />
            <WindowingControls image={image} color={color} />
        </OverlayRow>
    );
};

const WindowingOptions = () => {
    const primaryImage = useRecoilValue(primaryImageState);
    const secondaryImage = useRecoilValue(secondaryImageState);

    return (
        <Box display="grid" gap={0.5}>
            {primaryImage?.windowLevel && (
                <ImageWindowingRow image={primaryImage} color="primary.main" />
            )}
            {secondaryImage?.windowLevel && (
                <ImageWindowingRow
                    image={secondaryImage}
                    color="secondary.main"
                />
            )}
        </Box>
    );
};

export default WindowingOptions;
